import { type IUserCliDataResponse } from '../modules/user';
import { type Maybe } from '../types/utils';
import { axiosInstance } from './axiosInstance';

type TFetchSessionRepository = Maybe<{
  authorization: string;
  userData: IUserCliDataResponse;
}>;

type TSessionApiResponse = {
  authorization: string | null;
  userData: IUserCliDataResponse | null;
};

async function fetchSession(): Promise<TFetchSessionRepository | null> {
  try {
    const requestOptions = {
      url: `${process.env.NEXT_PUBLIC_API_CLIENTS}/auth/session`,
      method: 'GET',
    } as const;

    const { data } = await axiosInstance<TSessionApiResponse>(requestOptions);

    if (!data.authorization || !data.userData) {
      return null;
    }

    return { authorization: data.authorization, userData: data.userData };
  } catch {
    return null;
  }
}

export { fetchSession };
